import ContentDescriptionModuleForm from './ContentDescriptionModuleForm';

export default ContentDescriptionModuleForm;
